// PictureView.js

import { View } from 'backbone';
import BaseControlView from 'BaseControlView.js';
import template from 'common-visuals/control-picture.ejs';
import restService from 'RestService.js';
import util from 'util/Util.js';
import dummypic from 'dummypic.png';
import eventBus         from 'EventBus.js';
import constants                from 'Constants.js';

//=====================================================================
//
// A content view for an image reference.
//
// Lou Mauget, December 8, 2015
//
//=====================================================================
class PictureControlView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );

            this.template = template;
            this.tagName = 'div';
            this.events = {};

            let image= new Image();
            image.src=this.model.get('picture');
            let self =this;

            this.listenTo(this.model, 'change', this.render);
            this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
            return this;
        }

        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'PictureControlView';
        }
    
        adjustPictureSettings() {       
        if (this.model.get('assetId')==='none') {
            this.model.set('picture', dummypic, {silent: true} );
        } else {
            if(this.model.get('assetId')){
                this.model.set('picture', restService.getAssetURL(this.model.get('assetId')), {silent: true});
            }
        }

        let bStretch = util.isTrue(this.model.get('stretch'));
        let bMaintainRatio = util.isTrue(this.model.get('maintainAspectRatio'));

        let styleTag = '';
        if (!bStretch){
            styleTag = '';
            this.model.set('pictureStyle', styleTag, {silent:true});
        } else if (bStretch && !bMaintainRatio) {
            styleTag = `height: 100%; width: 100%; max-height: ${util.extractNum(this.model.get('height'))}px ;max-width: ${util.extractNum(this.model.get('width'))}px`;
            this.model.set('pictureStyle', styleTag, {silent:true});
        } else if(bStretch && bMaintainRatio) {
            
             const picHeight = util.extractNum(this.model.get('height'));
             const picWidth = util.extractNum(this.model.get('width'));
             const imageToAdjust=$('#' + this.model.get('id') + ' .pf-selectable img');

             let naturalWidth = imageToAdjust.prop('naturalWidth');
             let naturalHeight = imageToAdjust.prop('naturalHeight');

             if(naturalWidth && naturalHeight){
                this.model.set('naturalWidth', naturalWidth, {silent: true});
                this.model.set('naturalHeight', naturalHeight, {silent: true});
             } else{
                naturalWidth = this.model.get('naturalWidth');
                naturalHeight = this.model.get('naturalHeight');
            }
         
            // Performing calculation based on real image size
             let adjustedHeight = naturalWidth > 1 ? picWidth * naturalHeight /  naturalWidth : picHeight;
             let adjustedWidth = naturalHeight > 1 ? picHeight * naturalWidth / naturalHeight : picWidth;
             
             adjustedHeight = isNaN(adjustedHeight) ? picHeight : Math.trunc(adjustedHeight);
             adjustedWidth = isNaN(adjustedWidth) ? picWidth : Math.trunc(adjustedWidth);
             
             styleTag = `max-width: ${picWidth}px;max-height: ${picHeight}px;height:${adjustedHeight}px;width:${adjustedWidth}px`;

             // PF-4476 Removed this code as the function is called as part of the render process and its triggering a change on control model.
            // Not needed to send a change a without the silent as the control is being rendered.
             this.model.set('pictureStyle', styleTag, {silent:true});

        }
    }

}

export default PictureControlView;
